import React, { forwardRef, useRef, useState, useEffect } from "react";
import "./SlidingNavigationBar2.css";
// import { useDispatch } from "react-redux";
// import { setInnerLoaderFalse, setInnerLoaderTrue } from "../../../Redux/loaderSlice";
// import { t } from "i18next";


import { NavLink } from "react-router-dom";
// import { useStatics } from "../../../hooks/useStatics";
import { rootUrl } from "../../../App";
import { useThemeColor } from "../../../hooks/useThemeColor";

const SlidingNavigationBar2 = forwardRef(({ sliderData, selectedFragmentId, pageName }, ref) => {
    // const navigate = useNavigate();
    // const dispatch = useDispatch();

    // const { thumbnail } = useStatics();
    const { colorMode } = useThemeColor();

    const deviceWidth = (window.innerWidth > 991) ? ((window.innerWidth) * (33 / 100)) : (window.innerWidth);
    const dataWidth = (sliderData?.length) * 65;

    // console.log(deviceWidth, dataWidth, dataWidth - deviceWidth + "px");

    const scrollContainerRef = useRef(null);

    const [showRightButton, setShowRightButton] = useState(true);

    // console.log(selectedFragmentId, navbarData, selectedItem?.gameList);

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;

        const handleScroll = () => {
            if (scrollContainer) {
                const newPosition = scrollContainer.scrollLeft;
                // setScrollPosition(newPosition);

                // Toggle button visibility based on scroll position
                setShowRightButton(true);
                if (newPosition <= 0) {
                    // setShowLeftButton(false); // Hide left button at the beginning
                } else if (newPosition >= scrollContainer.scrollWidth - scrollContainer.clientWidth) {
                    setShowRightButton(false); // Hide right button at the end
                } else {
                    // setShowLeftButton(true);
                }
            }
        };

        // Add the scroll event listener
        scrollContainer.addEventListener("scroll", handleScroll);

        // Remove the event listener when the component unmounts
        return () => {
            if (scrollContainer) {
                scrollContainer.removeEventListener("scroll", handleScroll);
            }
        };
    }, []);

    useEffect(() => {
        if (deviceWidth > dataWidth) {
            setShowRightButton(false);
        } else {
            setShowRightButton(true);
        }
    }, [deviceWidth, dataWidth]);

    return (
        <div className="mt-0 mb-0 slidingNavbar2">
            <div className={(sliderData?.length > 5) ? "d-flex justify-content-start align-items-center slidingNavbar-scroll-width" : "d-flex justify-content-start align-items-center"}
                width={
                    ((deviceWidth < dataWidth) && (sliderData?.length > 5))
                        ? `calc(100% - ${dataWidth - deviceWidth}px)`
                        : "100vw"
                }
                style={{ backgroundColor: (colorMode === "light") ? "transparent" : "transparent", color: (colorMode === "light") ? "var(--dark)" : "var(--white)", }}>
                <div style={{ overflowX: "auto", overflowY: "hidden", whiteSpace: "nowrap", scrollbarWidth: 0, }} ref={scrollContainerRef}>
                    <div className={pageName === "Home" ? "hstack gap-0" : pageName === "Sports Exchange" ? "hstack gap-1 px-0 py-1" : "hstack gap-1 px-0 py-1"}>
                        {
                            (sliderData) &&
                            sliderData?.map((item, index) =>
                                (
                                    (item?.top_menu)
                                    // &&
                                    // !(item?.title === "Exclusive")
                                )
                                &&
                                <div key={item?.id}
                                    className="position-relative"
                                >
                                    <NavLink
                                        className={(navInfo) => (navInfo.isActive ? "nav-active custom-shadow" : "nav-link custom-shadow")}
                                        to={item?.page?.name}
                                        onClick={(event) => {
                                            if (item?.title === "Exclusive") {
                                                event.preventDefault(); // Prevent navigation for "Exclusive"
                                            }
                                        }}
                                    // style={{
                                    //     color: (index === 0) && "var(--golden)"
                                    // }}
                                    // onClick={() => {
                                    //     dispatch(setInnerLoaderTrue());

                                    //     navigate(item?.to);

                                    //     const timer = setTimeout(() => {
                                    //         dispatch(setInnerLoaderFalse());
                                    //     }, 2000);
                                    //     return () => clearTimeout(timer);
                                    // }}
                                    >
                                        <div className={"d-flex flex-column justify-content-end align-items-end m-0 mb-3 p-0"}>
                                            {
                                                (item?.thumbnail) &&
                                                <img className="" src={rootUrl + item?.thumbnail} alt={item?.alt_text} />
                                            }
                                        </div>
                                        <span className="text-overlay d-flex justify-content-center align-items-end rounded fw-bold" style={{
                                            // bottom: "0 !important",
                                        }}>
                                            {item?.title}
                                        </span>
                                    </NavLink>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
            <div className="slider-controls">
                {
                    showRightButton &&
                    <div className="position-absolute d-flex justify-content-center align-items-center"
                    >
                        <div
                            className="chevronWrapper"
                        >
                            <div className="chevron"></div>
                            <div className="chevron"></div>
                            <div className="chevron"></div>
                        </div>

                    </div>
                }
            </div>
        </div>
    );
});

export default SlidingNavigationBar2;